module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"try":"Nice try","no":"But not","text":"Try to test the other website","link":"Click"},"ru":{"try":"Nice try","no":"But not","text":"Try to test the other website","link":"Click"}}')
  delete Component.options._Ctor
}
